import { ModuleDropdownProps } from '@ghq-abi/design-system';
import { useTranslate } from '@tolgee/react';

import { EntitiesEnum } from '~/shared/auth/permissions';
import { Icon } from '~/shared/components';
import { useAbility } from '~/shared/contexts';

const style = {
  color: '#191F2E',
  size: 16
};

export function useModuleItems() {
  const { t } = useTranslate();
  const ability = useAbility();

  const items: ModuleDropdownProps['items'] = [
    {
      label: t('modules.my_compensation'),
      subtitle: t('menu.rewards'),
      icon: <Icon.MoneyBag color={style.color} size={style.size} />,
      url: process.env.NEXT_PUBLIC_MY_COMPENSATION_URL
    },
    {
      label: t('modules.my_talent_card'),
      subtitle: t('menu.opr'),
      icon: <Icon.Badge color={style.color} size={style.size} />,
      url: process.env.NEXT_PUBLIC_MY_TALENT_CARD_URL
    },
    {
      label: t('modules.my_targets'),
      subtitle: t('menu.northstar'),
      icon: <Icon.Target color={style.color} size={style.size} />,
      url: process.env.NEXT_PUBLIC_MY_TARGETS_URL
    }
  ];

  if (ability.can('view', EntitiesEnum.Cheershub)) {
    items.unshift({
      label: t('modules.cheershub'),
      subtitle: t('modules.cheershub'),
      icon: <Icon.Cheershub color={style.color} size={style.size} />,
      url: process.env.NEXT_PUBLIC_CHEERSHUB_URL
    });
  }

  return { items };
}
